import NAME from "./constants";

export const SEND_MESSAGE = NAME + "/SEND_MESSAGE";
export const SEND_MESSAGE_REJECTED = NAME + "/SEND_MESSAGE_REJECTED";
export const SEND_MESSAGE_FULFILLED = NAME + "/SEND_MESSAGE_FULFILLED";

export const DELETE_CONVERSATION = NAME + "/DELETE_CONVERSATION";